import React from "react";
import css from "./loader.module.css";

const Loader = () => {
  return (
    <div className={css.loaderContainer}>
      <div className={css.spinner}></div>
    </div>
  );
};

export default Loader;
